export const printOutsideContextProviderMessage = (contextProviderName: string) => {
  console.log(`${contextProviderName}: not in scope!`);
};
